var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "neu-card-professionals-ctn" }, [
    _c(
      "div",
      { staticClass: "neu-card-professionals btn-min-height mx-auto" },
      [
        _c("div", [
          _c("img", {
            staticClass: "vertical icon-width-prof",
            staticStyle: {
              "background-image":
                "url('/static-appopensalud/img/bgs/opt/doctor-male.svg')",
              "background-size": "cover"
            },
            attrs: { src: _vm.src }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "subtitle-professional mx-auto" },
          [
            _c("p", { domProps: { innerHTML: _vm._s(_vm.paddedTitle) } }),
            _vm._v(" "),
            _c("star-rating", {
              staticStyle: { "justify-content": "space-around" },
              attrs: {
                "star-size": 20,
                "read-only": true,
                "show-rating": false
              }
            }),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.paddedSubtitle) } })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08d62218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08d62218","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardProfessional.vue
// module id = 3731
// module chunks = 139